import React, { Fragment, useState, useEffect } from "react";
import { Table } from "reactstrap";
import { Colxx } from "../../../components/shared/CustomBootstrap";
import { Row, Input, Label, Button, FormGroup } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { fetchPreferences, updatePreferences } from "../../../redux/action";
import underscore from "underscore";
import { Box, Select, CardHeader, Card, CardBody } from "@chakra-ui/react";
import $ from "jquery";
import { changeFontSize } from "../../../redux/action";

export default function Preferences() {
  const size = useSelector((state) => state.settings.fontsize);
  const [fontSize, setFontSize] = useState(size);

  const handleFontSizeChange = (event) => {
    const selectedFontSize = event.target.value;
    setFontSize(selectedFontSize);
    dispatch(changeFontSize(selectedFontSize));
    localStorage.setItem("userfont", selectedFontSize);
  };

  const dispatch = useDispatch();
  const preferences = useSelector((state) => state.preferences);
  const [currentState, setCurrentState] = useState({
    isLoading: true,
    data: {
      send_to_voicemail: 1,
      show_notes: 1,
      show_delete: 1,
      forward_calls: 0,
      forward_calls_phones: "",
      is_signature: 0,
      signature_text: "",
    },
  });

  const getPreferences = () => {
    dispatch(fetchPreferences());
    setCurrentState({ data: preferences, isLoading: true });
  };

  const updateTextInput = (target) => {
    let { data } = currentState;
    if (target.type == "checkbox") {
      data[target.name] = data[target.name] == 0 ? 1 : 0;
    } else {
      data[target.name] = target.value;
    }
    setCurrentState({ ...currentState, data });
  };

  const updateData = () => {
    let { data } = currentState;
    console.log(data);
    setCurrentState({ isLoading: false, data });
    dispatch(updatePreferences(data));
    //getPreferences()
  };

  useEffect(() => {
    getPreferences();
  }, []);

  return (
    <Fragment>
      <Row>
        <Colxx xxs="12">
          <Card className="dashboard-link-list">
            <CardBody>
              <FormGroup row>
                <Colxx>
                  <Label className="pt-0">Send calls to voicemail</Label>
                </Colxx>
                <Colxx>
                  <FormGroup check>
                    <Input
                      type="checkbox"
                      name="send_to_voicemail"
                      checked={currentState.data.send_to_voicemail}
                      placeholder="Send calls to voicemail"
                      onChange={(e) => {
                        updateTextInput(e.target);
                      }}
                    />
                  </FormGroup>
                </Colxx>
              </FormGroup>

              <FormGroup row>
                <Colxx>
                  <Label className="pt-0">
                    Show notes in messages and voicemail
                  </Label>
                </Colxx>
                <Colxx>
                  <FormGroup check>
                    <Input
                      type="checkbox"
                      name="show_notes"
                      checked={currentState.data.show_notes}
                      placeholder="Show Notes"
                      onChange={(e) => {
                        updateTextInput(e.target);
                      }}
                    />
                  </FormGroup>
                </Colxx>
              </FormGroup>

              <FormGroup row>
                <Colxx>
                  <Label className="pt-0">
                    Show confirm box before deleting messages
                  </Label>
                </Colxx>
                <Colxx>
                  <FormGroup check>
                    <Input
                      type="checkbox"
                      name="show_delete"
                      checked={currentState.data.show_delete}
                      placeholder="Show confirm box before deleting messages"
                      onChange={(e) => {
                        updateTextInput(e.target);
                      }}
                    />
                  </FormGroup>
                </Colxx>
              </FormGroup>

              <FormGroup row>
                {/* <Row>  */}
                {/* ff_change change is here*/}
                <Colxx>
                  <Label className="pt-0">
                    Forward missed calls to a new number
                  </Label>
                </Colxx>
                <Colxx>
                  <FormGroup check>
                    <Input
                      type="checkbox"
                      name="forward_calls"
                      checked={currentState.data.forward_calls}
                      placeholder="Forward missed calls to a new number"
                      onChange={(e) => {
                        updateTextInput(e.target);
                      }}
                    />
                  </FormGroup>
                </Colxx>
                {/* </Row> */}
              </FormGroup>

              <FormGroup row>
                <Colxx>
                  <FormGroup check>
                    <Input
                      type="textarea"
                      name="forward_calls_phones"
                      placeholder="Enter phone number(s) you wish to forward missed calls to. If you wish to enter more than one phone number, place a comma between the phone numbers. Use this format to enter the phone number: 000-000-0000"
                      value={currentState.data.forward_calls_phones}
                      onChange={(e) => {
                        updateTextInput(e.target);
                      }}
                    />
                  </FormGroup>
                </Colxx>
                <Colxx></Colxx>
              </FormGroup>

              <FormGroup row>
                {/* <Row>  */}
                {/* ff_new_change change is here*/}
                <Colxx>
                  <Label className="pt-0">Show signature </Label>
                </Colxx>
                <Colxx>
                  <FormGroup check>
                    <Input
                      className="mt-2"
                      type="checkbox"
                      name="is_signature"
                      checked={currentState.data.is_signature}
                      placeholder="Forward missed calls to a new number"
                      onChange={(e) => {
                        updateTextInput(e.target);
                      }}
                    />
                  </FormGroup>
                </Colxx>
                {/* </Row> */}
              </FormGroup>

              <FormGroup row>
                <Colxx>
                  <FormGroup check>
                    <Input
                      className="mt-2"
                      type="text"
                      name="signature_text"
                      placeholder="Signature text"
                      value={currentState.data.signature_text}
                      onChange={(e) => {
                        updateTextInput(e.target);
                      }}
                    />
                  </FormGroup>
                </Colxx>
                <Colxx></Colxx>
              </FormGroup>

              <FormGroup>
                <Button
                  color="primary"
                  className="large ml-1 mt-2"
                  onClick={() => {
                    updateData();
                  }}
                  disabled={underscore.isEqual(currentState.data, preferences)}>
                  {" "}
                  Update
                </Button>
              </FormGroup>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
      <Card mt="20px" px="20px" pb="20px">
        <Box mt="40px" display="flex" gap="20px" alignItems="center">
          <Box
            textTransform="capitalize"
            fontSize={
              size === "small"
                ? "18px"
                : size === "medium"
                ? "20px"
                : size === "large"
                ? "24px"
                : "24px"
            }
            fontWeight="600">
            Change your font size here
          </Box>
          <Box flex="1">
            <Select value={fontSize} onChange={handleFontSizeChange}>
              <option value="small">Small</option>
              <option value="medium">Medium</option>
              <option value="large">Large</option>
            </Select>
          </Box>
        </Box>
        <Box mt="20px">
          <Card>
            <CardHeader
              textTransform="capitalize"
              fontSize={
                size === "small"
                  ? "18px"
                  : size === "medium"
                  ? "20px"
                  : size === "large"
                  ? "22px"
                  : "22px"
              }
              fontWeight="600">
              Fontsize details
            </CardHeader>
            <CardBody>
              <Box display={"flex"} alignItems="center" gap="5px">
                <Box
                  textTransform="capitalize"
                  fontSize={
                    size === "small"
                      ? "16px"
                      : size === "medium"
                      ? "18px"
                      : size === "large"
                      ? "20px"
                      : "20px"
                  }
                  fontWeight="600">
                  Current Size:
                </Box>
                <Box
                  textTransform="capitalize"
                  fontSize={
                    size === "small"
                      ? "14px"
                      : size === "medium"
                      ? "16px"
                      : size === "large"
                      ? "18px"
                      : "18px"
                  }
                  mt="2px">
                  {fontSize}
                </Box>
              </Box>
            </CardBody>
          </Card>
        </Box>
      </Card>
    </Fragment>
  );
}
